// document.addEventListener("DOMContentLoaded", function() {
window.addEventListener("load", function() {
  jQuery('.packages_tab').click(function(){
    jQuery('.packages_tab').removeClass('active_tab');
    jQuery(this).addClass('active_tab');
    if(jQuery(this).attr('id') == 'ti_packages_luau'){
      jQuery('.package-content_row:not(.luau)').addClass('hidden');
    }else{
      jQuery('.package-content_row.hidden').removeClass('hidden');
    }
  });
  var yotpo = jQuery(".yotpo.yotpo-main-widget");
  jQuery(yotpo).each(function(e){
  var product_id = jQuery(this).attr("data-product-id");
  var parentRow = jQuery(this).parents('.package-content_row');
  var app = "sWBtndKyAWoEcLWLGmgXL1Th0oz1TR324Vwla7Ba"; // YOTPO is most likely not available to grab the key dynamically.
  jQuery.ajax({
    method: "GET",
    url: "https://api.yotpo.com/products/" + app + "/" + product_id + "/bottomline",
    success: function(response) {
      var bottomline = response.response.bottomline;

      // jQuery(".package_info__review-rating").html(Number.parseFloat(bottomline.average_score).toFixed(1));
      if(parentRow.length){
        console.log("parent exists", parentRow )
        jQuery(parentRow).find(".package_info__review-count span").html(bottomline.total_reviews);
        jQuery(".package_info__review-count").click(function() {
          scrollToElement(jQuery(".yotpo.yotpo-main-widget").eq(0));
        });

        var starCounter = bottomline.average_score;
        for (var x=0; x < 5; x++) {
          var star = document.createElement("span");
          var starClass = "yotpo-icon rating-star pull-left ";
          starClass += (starCounter > 0
            ? starCounter < 1
              ? "yotpo-icon-half-star"
              : "yotpo-icon-star"
            : "yotpo-icon-empty-star");
          star.setAttribute("class", starClass);
          jQuery(parentRow).find(".package_info__review-stars").append(star);
          starCounter--;
        }
      }else{
        console.log("no parent exists")
        jQuery(".package_info__review-count span").html(bottomline.total_reviews);
        jQuery(".package_info__review-count").click(function() {
          scrollToElement(jQuery(".yotpo.yotpo-main-widget").eq(0));
        });

        var starCounter = bottomline.average_score;
        for (var x=0; x < 5; x++) {
          var star = document.createElement("span");
          var starClass = "yotpo-icon rating-star pull-left ";
          starClass += (starCounter > 0
            ? starCounter < 1
              ? "yotpo-icon-half-star"
              : "yotpo-icon-star"
            : "yotpo-icon-empty-star");
          star.setAttribute("class", starClass);
          jQuery(".package_info__review-stars").append(star);
          starCounter--;
        }
      }
    },
    error: function(response) {
      console.log("ERROR!!!", response.responseJSON || response.responseText);
    }
  });

  function scrollToElement(element) {
    $("html, body").animate({ scrollTop: element.offset().top }, 400);
  }
});
});
